import { LinearProgress } from 'material-ui';
import React from 'react';
import { cdnPath } from '../../constants/config';

class AchievementCard extends React.Component {
    constructor(props){
        super(props);
    }

    getIcon = () => {
        switch(this.props.color){
            case 'red':
            return `https://${cdnPath}/mobilenext/images/red-large-3x.png`;
            case 'green':
            return `https://${cdnPath}/mobilenext/images/green-large-3x.png`;
            case 'blue':
            return `https://${cdnPath}/mobilenext/images/blue-large-3x.png`;
        }
    }

    getColor = () => {
        switch(this.props.color){
            case 'red':
            return "#E85E56"
            case 'green':
            return "#85B01E"
            case 'blue':
            return "#4AB4E6"
        }
    }

    render(){
        return (
            <div className={'ach-card-container'}>
                <div style={{paddingTop:8, width: 85}}>
                    <img src={this.getIcon()} style={{width:'75px', margin: '0 auto'}} />
                </div>
                <div className={'ach-card-column-container'}>
                    <div className={'ach-card-column'}>
                        <div className={'ach-card-title'}>{this.props.name}</div>
                        <div className={'ach-progress-bar-container'}>
                            <div className={'ach-prog-text-container grey-font'}>
                                <div className={'ach-prog-text'}>{this.props.bartext}</div>
                                <div className={'ach-prog-text'}>{this.props.goal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
                            </div>
                            <div className={'ach-prog-bar-bar'}>
                                <LinearProgress color={this.props.color} mode="determinate" value={(this.props.value/this.props.goal * 100)}/>
                            </div>
                            <div className={'ach-prog-text-container grey-font'}>
                                <div className={'ach-prog-text'}>You've achieved this goal: <span style={{fontWeight:600, color:this.props.color}}>{this.props.count}</span> times{this.props.count == 0 ? "." : "!"}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default AchievementCard;


// WEBPACK FOOTER //
// ./src/Components/ActivityTracker/AchievementCard.js